export * from '@primeuix/themes/aura/tag';
export { default } from '@primeuix/themes/aura/tag';
